import {Dialog, DialogContent, DialogActions, DialogTitle, Typography, Button, Backdrop} from '@mui/material';
import {useTheme} from '@mui/material/styles';

import React from 'react';

/**
 * Component representing a confirmation dialog.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.confirmDialog - Information about the dialog.
 * @param {Function} props.setConfirmDialog - Function to update the dialog state.
 * @returns {JSX.Element} The ConfirmationDialog component.
 */
const ConfirmationDialog = props => {
  const {confirmDialog, setConfirmDialog} = props;
  const theme = useTheme();

  const dialogStyle = {
    '& .MuiPaper-root': {
      borderRadius: '20px',
    },
    position: 'absolute',
    top: theme.spacing(5),
    paddingY: theme.spacing(2),
  };

  return (
    <Dialog
      open={confirmDialog.isOpen}
      maxWidth="sm"
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      sx={dialogStyle}
    >
      <DialogTitle
        sx={{
          paddingTop: theme.spacing(6),
          pb: theme.spacing(1),
          textAlign: 'center',
        }}
      >
        <Typography component="span" variant="h6" fontWeight={'bold'}>
          {confirmDialog.title}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{paddingY: theme.spacing(5), textAlign: 'center'}}>
        <Typography variant="subtitle2"> {confirmDialog.subTitle}</Typography>
      </DialogContent>
      <DialogActions
        sx={{
          paddingBottom: theme.spacing(2),
          paddingX: theme.spacing(4),
          display: 'flex',
          justifyContent: 'space-between',
          gap: 9,
        }}
      >
        <Button
          variant="text"
          sx={{
            width: confirmDialog.noConfirmText === '' ? '0%' : undefined,
            p: confirmDialog.noConfirmText === '' ? '0' : undefined,
          }}
          onClick={() => {
            confirmDialog?.onDeny?.();
            setConfirmDialog({
              ...confirmDialog,
              isOpen: false,
            });
          }}
        >
          {confirmDialog?.noConfirmText ?? 'No, close this window.'}
        </Button>
        <Button variant="text" onClick={confirmDialog.onConfirm}>
          {confirmDialog?.confirmText ?? 'Yes, cancel.'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
